export default __webpack_public_path__ + "static/media/SV.96309b92.ico";